import apiV2 from "api-v2";

import type {
	ImportedQuoteAnalyzeResponse,
	ImportedQuoteTable,
} from "../types/imported-quote-table.type";

/**
 * Surface-agnostic contract for a spreadsheet-import backend. Each import
 * surface (RFx, RFx-template, Quote-settings) provides one of these; the shared
 * preview modal is parameterised by it and never hardcodes an endpoint. This is
 * the seam tasks 007/010 plug their own api modules into.
 */
export interface QuoteImportApi {
	/** POST the workbook and return the editable preview IR (no writes). */
	analyze: (file: File) => Promise<ImportedQuoteAnalyzeResponse>;
	/** Persist the confirmed tables. */
	apply: (tables: ImportedQuoteTable[]) => Promise<void>;
}

/**
 * POST a workbook as multipart form-data and return the analyze IR. Shared by
 * every import-api surface so the multipart wiring lives in exactly one place
 * (PRO-574 — no duplicated helpers across the RFx / template / settings modules).
 */
export const postAnalyzeMultipart = async (
	path: string,
	file: File
): Promise<ImportedQuoteAnalyzeResponse> => {
	const formData = new FormData();
	formData.append("file", file);
	const response = await apiV2.post<{ data: ImportedQuoteAnalyzeResponse }>(
		path,
		formData,
		{ headers: { "Content-Type": "multipart/form-data" } }
	);
	return response.data.data;
};
